import {faCashRegister} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {dateFormatFR} from '../../../utils';
import DataTable from '../../../common/components/Datatable/Datatable';
import SelectMerchant from '../../../common/components/SelectMerchant';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR} from '../../../common/constants';
import {GRAPHQL_QUERY_CHECKOUTS} from '../../../common/queries/checkout';
import AddCheckout from './AddCheckout';
import CheckoutRowActionAdmin from './CheckoutRowActionAdmin';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

const SelectMerchantContainer = styled.div`
   margin: 5px;
   width: 250px;
`;


const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('name'),
    accessor: 'name',
    sortable: true,
  },
  {
    Header: t('serial'),
    Cell: ({cell}) => cell.value || t('notSpecified'),
    accessor: 'serial',
    sortable: true,
  },
  {
    Header: t('merchantName'),
    accessor: 'merchant.businessName',
    sortable: true,
  },
  {
    Header: t('brand'),
    accessor: 'merchant.brand.name',
    sortable: true,
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
    sortable: true,
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <CheckoutRowActionAdmin checkout={cell.value}/>,
    accessor: row => row,
  },
];

const createFilters = (search, merchantFilter) => {
  const merchantFilterObject = !merchantFilter ? null : {
    operator: FILTER_EXPRESSION_OPERATOR.And,
    filters: {
      field: 'merchant.id',
      value: merchantFilter,
    },
  };

  const expressions = [{
    operator: FILTER_EXPRESSION_OPERATOR.Or,
    filters: [{
      field: 'checkout.id',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'checkout.name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'serial',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.firstName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.lastName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'brand.name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'merchant.businessName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }],
  }];

  if (merchantFilter) {
    expressions.push(merchantFilterObject);
  }

  return {
    expressions,
    relations: ['merchant', 'user', 'brand'],
  };
};

const CheckoutListAdmin = ({t}) => {
  const [merchantFilter, setMerchantFilter] = useState('');
  const [search, setSearch] = useState('');

  const additionalFilters = (
    <SelectMerchantContainer>
      <SelectMerchant
        placeholder={t('merchantFilter')}
        lightStyles={true}
        onChange={option => {
          if (option && option.value) {
            setMerchantFilter(option.value);
          } else {
            setMerchantFilter('');
          }
        }}
        isClearable={true}/>
    </SelectMerchantContainer>
  );

  return (
    <Screen
      header={<Metadata title={t('title')} meta={t('meta')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faCashRegister} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('checkouts')}</Span>
        </>}
      rightTitle={<AddCheckout/>}
    >
      <Row>
        <Col xs={12}>
          <DataTable
            columns={columns(t)}
            keyResult="checkouts"
            query={GRAPHQL_QUERY_CHECKOUTS}
            defaultSort={{field: 'name'}}
            advancedFilters={createFilters(search, merchantFilter)}
            additionalFilters={additionalFilters}
            onSearch={value => setSearch(value)}/>
        </Col>
      </Row>
    </Screen>
  );
};

CheckoutListAdmin.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('checkout')(CheckoutListAdmin);
